import RequestOptions from 'owa-service/lib/RequestOptions';

const ucmaServiceOptions: RequestOptions = {
    noEmptyPost: true,
};

export default ucmaServiceOptions;
